module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"textContentFallback":"Não encontramos dados para o período selecionado."},"en-US":{"textContentFallback":"We found no data for the selected period."}}')
  delete Component.options._Ctor
}
